var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelegramIconFillAble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.845 16.1019C24.845 20.9302 20.9308 24.8444 16.1025 24.8444C11.2741 24.8444 7.35999 20.9302 7.35999 16.1019C7.35999 11.2735 11.2741 7.35938 16.1025 7.35938C20.9308 7.35938 24.845 11.2735 24.845 16.1019ZM16.9403 13.4193C15.4383 14.068 11.1078 15.9104 11.1078 15.9104C10.0814 16.3256 10.6822 16.7148 10.6822 16.7148C10.6822 16.7148 11.5583 17.0262 12.3093 17.2598C13.0603 17.4933 13.4608 17.2338 13.4608 17.2338C13.4608 17.2338 15.2131 16.0402 16.9903 14.7686C18.2419 13.8864 17.9416 14.6129 17.6412 14.9244C16.9903 15.599 15.914 16.6629 15.0128 17.5193C14.6123 17.8826 14.8125 18.1939 14.9878 18.3496C15.4974 18.7967 16.6977 19.6096 17.2426 19.9787C17.3936 20.081 17.4943 20.1492 17.516 20.1661C17.6412 20.2699 18.3421 20.737 18.7676 20.6332C19.1932 20.5294 19.2432 19.9325 19.2432 19.9325C19.2432 19.9325 19.5687 17.8047 19.8691 15.8585C19.9247 15.4764 19.9803 15.1023 20.0322 14.7535C20.1671 13.8468 20.2765 13.1108 20.2946 12.8484C20.3697 11.9661 19.4685 12.3294 19.4685 12.3294C19.4685 12.3294 17.516 13.1598 16.9403 13.4193Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIconFillAble);
export default __webpack_public_path__ + "static/media/telegramIconFillAble.db3fb77e.svg";
export { ForwardRef as ReactComponent };